module.exports = __webpack_public_path__ + "img/mouth-1-5.2f620978.svg";